import { Routes } from '@angular/router';
import { PORTAL, USER_ROLE } from './core/models/auth.models';
import { environment } from '../environments/environment';
import { accessGuard, type AccessRouteData } from './core/guards/access.guard';

export function getRoutes(env: string): Routes {
  const isDev = env === 'local' || env === 'development';
  const devRoutes: Routes = isDev
    ? [
        {
          path: 'helper',
          loadComponent: () =>
            import('./features/helper/helper.component').then((m) => m.HelperComponent),
        },
      ]
    : [];

  return [
    ...devRoutes,
    {
      path: 'admin',
      children: [
        {
          path: 'login',
          canActivate: [accessGuard],
          data: { portal: PORTAL.ADMIN, allowAnonymous: true } satisfies AccessRouteData,
          loadComponent: () =>
            import('./features/admin/login/login.component').then((m) => m.LoginComponent),
        },
        {
          path: '',
          canActivate: [accessGuard],
          data: {
            portal: PORTAL.ADMIN,
            allowedRoles: [USER_ROLE.ADMIN, USER_ROLE.STAFF],
          } satisfies AccessRouteData,
          loadChildren: () => import('./features/admin/admin.routes').then((m) => m.adminRoutes),
        },
      ],
    },
    {
      path: '',
      canActivate: [accessGuard],
      data: { portal: PORTAL.PUBLIC, allowAnonymous: true } satisfies AccessRouteData,
      loadChildren: () => import('./features/public/public.routes').then((m) => m.publicRoutes),
    },
    {
      path: '**',
      loadComponent: () =>
        import('./features/not-found/not-found.component').then((m) => m.NotFoundPageComponent),
    },
  ];
}

export const routes: Routes = getRoutes(environment.env);
